// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bx--dropdown{border-bottom:none}.personalisation-method-selector-manager{display:flex;flex-direction:row;justify-content:space-evenly;width:100%;padding:10px}", ""]);
// Exports
module.exports = exports;
